import moment from 'moment'
export const PolizasEndososColumns = [
  {
    key: 'nro_pol',
    label: 'Póliza',
    sortable: true
  },
  {
    key: 'nro_endoso',
    label: 'Endoso',
    sortable: true
  },
  {
    key: 'fec_emi',
    label: 'Fec. Emisión',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_desde',
    label: 'Vig. Desde',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_hasta',
    label: 'Vig. Hasta',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'ramo',
    label: 'Ramo',
    sortable: true
  },
  {
    key: 'tomador',
    label: 'Tomador',
    sortable: true
  },
  {
    key: 'asegurado',
    label: 'Asegurado',
    sortable: true
  },
  {
    key: 'imp_suma_asegurada',
    label: 'Suma As.',
    sortable: true
  },
  {
    key: 'prima',
    label: 'Prima',
    sortable: true
  },
  {
    key: 'premio',
    label: 'Premio',
    sortable: true
  },
  {
    key: 'forma_pago',
    label: 'Forma de Pago',
    sortable: true
  }
];


export const AvisosVencimientoColumns = [
  {
    key: 'nro_pol',
    label: 'Póliza',
    sortable: true
  },
  {
    key: 'nro_endoso',
    label: 'Endoso',
    sortable: true
  },
  {
    key: 'fec_emi',
    label: 'Fec. Emisión',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_desde',
    label: 'Vig. Desde',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_hasta',
    label: 'Vig. Hasta',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'ramo',
    label: 'Ramo',
    sortable: true
  },
  {
    key: 'tomador',
    label: 'Tomador',
    sortable: true
  },
  {
    key: 'asegurado',
    label: 'Asegurado',
    sortable: true
  },
  {
    key: 'suma',
    label: 'Suma As.',
    sortable: true
  },
  {
    key: 'prima',
    label: 'Prima',
    sortable: true
  },
  {
    key: 'premio',
    label: 'Premio',
    sortable: true
  },
  {
    key: 'forma_pago',
    label: 'Forma de Pago',
    sortable: true
  }
];


export const RefacturacionesColumns = [
  {
    key: 'nro_pol',
    label: 'Póliza',
    sortable: true
  },
  {
    key: 'nro_endoso',
    label: 'Endoso',
    sortable: true
  },
  // {
  //   key: 'fec_emi',
  //   label: 'Fec. Emisión',
  //   sortable: true
  // },
  {
    key: 'fec_vig_desde',
    label: 'Vig. Desde',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_hasta',
    label: 'Vig. Hasta',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'ramo',
    label: 'Ramo',
    sortable: true
  },
  {
    key: 'tomador',
    label: 'Tomador',
    sortable: true
  },
  {
    key: 'asegurado',
    label: 'Asegurado',
    sortable: true
  },
  {
    key: 'suma',
    label: 'Suma As.',
    sortable: true
  },
  {
    key: 'prima',
    label: 'Prima',
    sortable: true
  },
  {
    key: 'premio',
    label: 'Premio',
    sortable: true
  },
  {
    key: 'forma_pago',
    label: 'Forma de Pago',
    sortable: true
  }
];

export const PolizasDeudaColumns = [
  {
    key: 'nro_pol',
    label: 'Póliza',
    sortable: true
  },
  {
    key: 'nro_endoso',
    label: 'Endoso',
    sortable: true
  },
  {
    key: 'fec_emi',
    label: 'Fec. Emisión',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_desde',
    label: 'Vig. Desde',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_hasta',
    label: 'Vig. Hasta',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'ramo',
    label: 'Ramo',
    sortable: true
  },
  {
    key: 'tomador',
    label: 'Tomador',
    sortable: true
  },
  {
    key: 'asegurado',
    label: 'Asegurado',
    sortable: true
  },
  {
    key: 'deuda',
    label: 'Deuda',
    sortable: true
  },
  {
    key: 'prima',
    label: 'Prima',
    sortable: true
  },
  {
    key: 'premio',
    label: 'Premio',
    sortable: true
  },
  {
    key: 'forma_pago',
    label: 'Forma de Pago',
    sortable: true
  }
];


export const PolizasAnuladasColumns = [
  {
    key: 'nro_pol',
    label: 'Póliza',
    sortable: true
  },
  {
    key: 'nro_endoso',
    label: 'Endoso',
    sortable: true
  },
  {
    key: 'fec_emi',
    label: 'Fec. Emisión',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_desde',
    label: 'Vig. Desde',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'fec_vig_hasta',
    label: 'Vig. Hasta',
    sortable: true,
    formatter: val => moment(val).format('DD/MM/YYYY')
  },
  {
    key: 'ramo',
    label: 'Ramo',
    sortable: true
  },
  {
    key: 'tomador',
    label: 'Tomador',
    sortable: true
  },
  {
    key: 'asegurado',
    label: 'Asegurado',
    sortable: true
  },
  {
    key: 'suma',
    label: 'Suma As.',
    sortable: true
  },
  {
    key: 'prima',
    label: 'Prima',
    sortable: true
  },
  {
    key: 'premio',
    label: 'Premio',
    sortable: true
  },
  {
    key: 'forma_pago',
    label: 'Forma de Pago',
    sortable: true
  }
];
